import { motion } from "framer-motion";
import { ConnectionPill } from "@/components/portal/ConnectionPill";

export const ValidatingStep = ({ connection }) => (
  <motion.div initial={{ opacity: 0, y: 15 }} animate={{ opacity: 1, y: 0 }} className="glass-card w-full max-w-xl p-8 text-center sm:p-12" data-testid="validating-step">
    <div className="relative mx-auto mb-8 h-20 w-20">
      <motion.span className="absolute inset-0 rounded-full border-2 border-transparent" style={{ borderTopColor: "var(--brand)", borderRightColor: "var(--brand)" }}
        animate={{ rotate: 360 }} transition={{ duration: 1.1, repeat: Infinity, ease: "linear" }} />
      <motion.span className="absolute inset-5 rounded-full" style={{ background: "radial-gradient(circle, var(--brand) 0%, transparent 70%)" }}
        animate={{ opacity: [0.5, 1, 0.5] }} transition={{ duration: 1.6, repeat: Infinity }} />
    </div>
    <h1 className="font-display text-2xl text-slate-50 sm:text-3xl" data-testid="validating-message">Aguarde, estamos validando os dados</h1>
    <p className="mt-4 text-sm text-slate-400">Não feche esta página. A tela será atualizada automaticamente.</p>
    <div className="mt-6 flex justify-center"><ConnectionPill status={connection} /></div>
  </motion.div>
);
